import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import LoadThemeComponent from '../../../../base/LoadThemeComponent';
import { Multiplier, SetStateFunction } from '../../Types/Types';

import InfoCircleTooltip from 'components/common/InfoCircleTooltip';
import { isPremierDubai } from 'utils/template';

type Props = {
    multiplier: number;
    setMultiplier: SetStateFunction<number>;
    useCounterClass: boolean;
    multipliers: Array<Multiplier>;
};

function MultiplierSelect({ multipliers, multiplier, setMultiplier, useCounterClass }: Props) {
    const { t } = useTranslation();

    const previousMultiplier = useRef<number>(0);

    useEffect(() => {
        previousMultiplier.current = multiplier;
    }, [multiplier]);

    useEffect(() => {
        // Keep selected correct multiplier when game type has changed and pool multipliers has changed
        let selectedMultiplier = multipliers.find((m) => m.multiplier === previousMultiplier.current)?.multiplier;
        if (!selectedMultiplier) {
            selectedMultiplier = multipliers[0].multiplier;
        }

        setMultiplier(selectedMultiplier);
    }, [multipliers]);

    function getMultipliersOptions() {
        return multipliers.map((item) => (
            <option key={item.multiplier} value={item.multiplier}>
                x{item.multiplier}
            </option>
        ));
    }

    const baseView = () => (
        <div className={`col-12 ${useCounterClass ? 'col-md-6 pr-md-2' : ''} pr-lg-2 col-lg pl-lg-3 purchase-opt-col`}>
            <div className="card options-card d-md-flex h-100">
                <div className="card-header">
                    {isPremierDubai() ? t('playPicker.multiplyEntriesBy') : t('playPicker.selectMultiplier')}
                    {!isPremierDubai() && <InfoCircleTooltip content={t('playPicker.selectMultiplierTooltip')} />}
                </div>
                <div className="card-body">
                    <select
                        name="multiplier"
                        id="multiplier-select"
                        className="form-control multiplier-select"
                        defaultValue={multiplier}
                        onChange={(event) => {
                            setMultiplier(parseInt(event.target.value));
                        }}
                    >
                        {getMultipliersOptions()}
                    </select>
                </div>
            </div>
        </div>
    );

    const defaultView = () => (
        <div className="col-12">
            <div className="card options-card d-md-flex h-100">
                <div className="card-header">
                    {isPremierDubai() ? t('playPicker.multiplyEntriesBy') : t('playPicker.selectMultiplier')}
                    {!isPremierDubai() && <InfoCircleTooltip content={t('playPicker.selectMultiplierTooltip')} />}
                </div>
                <div className="card-body">
                    <div className="multiplier-options mx-auto d-flex">
                        {multipliers.map((item) => (
                            <div
                                key={item.multiplier}
                                onClick={() => setMultiplier(item.multiplier)}
                                className={`multiplier-option ${multiplier === item.multiplier ? 'selected' : ''}`}
                            >
                                x{item.multiplier}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );

    return <LoadThemeComponent defaultView={defaultView} baseView={baseView} />;
}

export default MultiplierSelect;
